import React , { Component } from 'react';
import { Row, Col, Card, Input, Button } from 'antd';
import Cookies from 'js-cookie';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import AdminRoleSelect from './AdminRoleSelect'
import StatesSelect from '../../components/public/StatesSelect'
import { IAdminRoleInfo } from '../../service/admin/AdminRoleService';
import AdminTable from'./AdminTable';
import './page-admin.less';

interface AdminPageProps {
    roleOptions: IAdminRoleInfo[];
    getRoleName: (roleId: number, roleOptions: IAdminRoleInfo[]) => string;
}

interface AdminPageState {
    accInputValue: string;
    nameInputValue: string;
    roleSelectValue: number | null;
    statesSelectValue: number | null;
    roleOptions: IAdminRoleInfo[];
}

const ROLE_PARTS = [1000, 100, 10, 2, 1];
const splitRole = (roleValue: number) => {
    const result: number[] = [];
    if (!roleValue || roleValue <= 0) {
        return result;
    }
    let remain = roleValue;
    ROLE_PARTS.forEach((part) => {
        if (remain >= part) {
            remain -= part;
            result.push(part);
        }
    });
    if (remain !== 0) {
        return [roleValue];
    }
    return result;
};

//根据权限id获取对应权限名称
export const getRoleName = (roleId: number, roleOptions: IAdminRoleInfo[]) => {
    if (!roleOptions || roleOptions.length === 0) {
      return roleId.toString();
    }
    const parts = splitRole(roleId);
    const names = parts.map((part) => {
        const role = roleOptions.find((option) => option.roleId === part);
        return role ? role.roleName : part.toString();
    });
    return names.join('\n');
};

//define AdminPage class
class AdminPage extends Component<AdminPageProps, AdminPageState> {
    state = {
        accInputValue: '',
        nameInputValue: '',
        roleSelectValue: null,
        statesSelectValue: 0,
        roleOptions: [],
    };

    async componentDidMount() {
        await this.adminTableRef.getAdminTableData(1, this.state.roleSelectValue, this.state.accInputValue, 
            this.state.nameInputValue, this.state.statesSelectValue);
    }
    
    adminTableRef: AdminTable;

    canManageAdmin = () => {
        const roleValue = parseInt(Cookies.get('userRole') || '0', 10);
        const roleParts = splitRole(roleValue);
        return roleParts.includes(100) || roleParts.includes(1000);
    };

    handleAddButtonClick = () => {
        window.location.href = '/#/app/admin/manager';
    };

    //账号输入框处理
    AccInput = () => {
        const handleAccInputChange = (event: any) => {
            this.setState({ accInputValue: event.target.value });
        };

        return (
            <>
                <label className="label-admin_acc">账号：</label>
                <Input
                    placeholder="管理员账号"
                    className="input-admin_acc"
                    value={this.state.accInputValue}
                    onChange={handleAccInputChange}
                    allowClear
                />
            </>
        );
    };

    //用户名输入框处理
    NameInput = () => {
        const handleNameInputChange = (event: any) => {
            this.setState({ nameInputValue: event.target.value });
        };

        return (
            <>
                <label className="label-admin_name">用户名：</label>
                <Input 
                    placeholder="管理员用户名"
                    className="input-admin_name"
                    value={this.state.nameInputValue}
                    onChange={handleNameInputChange}
                    allowClear
                />
            </>
        );
    };

    //权限选择框事件处理
    handleRoleSelectChange = (value: any) => {
        this.setState({ roleSelectValue: value });
    };
    handleRoleSelectData = (value: IAdminRoleInfo[]) => {
        this.setState({ roleOptions: value });
    };

    //状态选择框事件处理
    handleStatesSelectChange = (value: any) => {
        this.setState({ statesSelectValue: value });
    };

    //查询按钮点击事件
    handleButtonClick = async () => {
        await this.adminTableRef.getAdminTableData(1, this.state.roleSelectValue, this.state.accInputValue, 
            this.state.nameInputValue, this.state.statesSelectValue);
    };

    render() {
        return (
            <div className="gutter-admin_table">
                <BreadcrumbCustom breads={['管理员信息管理', '管理员信息列表']} />
                <Row gutter={5}>
                    <Col className="gutter-admin_row" md={23}>
                        <div className="gutter-admin_box">
                            <Card title="管理员信息列表" bordered={false}>
                                <div style={{ marginBottom: 16 }}>
                                    <this.AccInput />

                                    <this.NameInput />

                                    <label className="label-admin_role">权限：</label>
                                    <AdminRoleSelect 
                                        onChange={this.handleRoleSelectChange} 
                                        roleOptionProps={this.handleRoleSelectData} 
                                    />

                                    <label className="label-states">状态：</label>
                                    <StatesSelect 
                                        onChange={this.handleStatesSelectChange}
                                    />

                                    <Button className="button-admin_query" type="primary" onClick={this.handleButtonClick}>
                                        查询
                                    </Button>

                                    {this.canManageAdmin() && (
                                        <Button className="button-admin_add" type="primary" onClick={this.handleAddButtonClick}>
                                            添加管理员
                                        </Button>
                                    )}
                                </div>
                                <div className="admin-table-wrapper">
                                    <AdminTable roleOptions={this.state.roleOptions} ref={(ref) => (this.adminTableRef = ref)} /> 
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AdminPage;
